module.exports = __webpack_public_path__ + "img/plus-in-circle.ed2a4de9.svg";